import { StyledBox, StyledImage, StyledStack } from './hero.styles';
import { IconLinks } from '../icon-links/icon-links';
import { LinkTree } from '../link-tree/link-tree';

export const Hero = () => {
  return (
    <StyledBox>
      <StyledStack spacing={2}>
        <StyledImage
          src="/images/CarlHauck_RGB bandcamp.jpg"
          alt="Death Farm Album Cover"
        />
        <IconLinks />
        <LinkTree />
      </StyledStack>
    </StyledBox>
  );
};